import { FaFacebookSquare, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaShop } from "react-icons/fa6";
import "../../styles/components/footer.css";

const data = require("../../data/data.json");
const externalLinks = require("../../data/externalLinks.json");

function Footer() {
  return (
    <footer
      className=".footer2"
      role="contentinfo"
      initial={{ y: 150 }}
      whileInView={{ y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <div className="footer-div0">
        <section>
          <h2>Información</h2>
          <a href="#about" title="Quiénes somos – B‑Sites">
            Nosotros
          </a>
          <a href="#services" title="Nuestros servicios – B‑Sites">
            Servicio
          </a>
          <a href="#pricing" title="Planes y precios – B‑Sites">
            Costos
          </a>
          <a href="#hero" title="Inicio – B‑Sites">
            Inicio
          </a>
        </section>

        <section>
          <h2>Contacto</h2>
          <a
            href={externalLinks.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Enviar mensaje por WhatsApp"
            title="Contáctanos por WhatsApp"
          >
            {data.PhoneNumber}
          </a>
          <a
            href="mailto:contacto@bsitescomp.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Enviar correo electrónico"
            title="Envíanos un email"
          >
            contacto@bsitescomp.com
          </a>
        </section>

        <section id="redes">
          <h2>Visítenos</h2>
          <div style={{ display: "flex", gap: "1rem" }}>
            <a
              href={externalLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="B‑Sites en Facebook"
              title="Síguenos en Facebook"
            >
              <FaFacebookSquare size={28} />
            </a>
            <a
              href={externalLinks.googleBusiness}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Opiniones en Google"
              title="Lee nuestras reseñas en Google"
            >
              <FaShop size={28} />
            </a>
            <a
              href={externalLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="B‑Sites en YouTube"
              title="Síguenos en YouTube"
            >
              <FaYoutube size={30} />
            </a>
            <a
              href={externalLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="B‑Sites en Instagram"
              title="Síguenos en Instagram"
            >
              <FaInstagram size={28} />
            </a>
          </div>
        </section>
      </div>

      <hr />

      <div className="footer-div1">
        <p>
          &copy; 2025 Web Developed by <strong>B‑Sites</strong>.
        </p>
        <a
          href="http://www.freepik.com"
          target="_blank"
          rel="noopener noreferrer"
          title="Créditos de imágenes design by Freepik"
        >
          Images Designed by Freepik
        </a>
      </div>
    </footer>
  );
}

export default Footer;
